import { React } from 'react'
import styled from 'styled-components'

export default function ItemPrice({ item }) {
    const StyledItemPriceContainer = styled.div`
        display: flex;
        flex-direction: column;
        justify-content: center;
        position: relative;
        height: 50px;
    `
    const StyledItemPrice = styled.div`
        font-size: 160%;
        font-weight: 700;
        display: flex;
        justify-content: center;
    `
    const StyledDiscount = styled.div`
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        right: -8px;
        top: -5px;
        width: 40px;
        height: 40px;
        background-color: #c10000;
        box-shadow: -2px 2px 15px #565656c7;
        color: white;
        border-radius: 50%;
        font-weight: bold;
        font-size: 90%;
    `
    let itemDiscount

    if (item.price && item.impactMoney) {
        itemDiscount =
            (item.price / (item.price + Number(item.impactMoney)) - 1) * 100
    }

    return (
        <StyledItemPriceContainer>
            {itemDiscount < 0 && (
                <StyledDiscount>{itemDiscount.toFixed(0) + '%'}</StyledDiscount>
            )}
            {item.price && (
                <StyledItemPrice>
                    {Number.isInteger(item.price)
                        ? item.price
                        : item.price.toFixed(2)}
                    &nbsp;.-
                </StyledItemPrice>
            )}
        </StyledItemPriceContainer>
    )
}
